import React from 'react';
import { useOptionalFilterState } from '../hooks/useFilter';

export type DocumentTitleProps = {
  title?: string;
};

const DocumentTitle = ({ title }: DocumentTitleProps) => {
  const filter = useOptionalFilterState();
  const company = filter.query?.company_id ? ` | ${filter.names.company}` : '';
  const project = filter.query?.project_id ? ` | ${filter.names.project}` : '';
  const sepTitle = title ? ` | ${title}` : '';
  React.useEffect(() => {
    const originalTitle = document.title;
    document.title =
      import.meta.env.VITE_APP_NAME + company + project + sepTitle;

    return () => {
      document.title = originalTitle;
    };
  }, [company, project, sepTitle, title]);
  return null;
};
export default DocumentTitle;
